import { amplitude, ga, adjust } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackCompleteRegistration = ({
  profile,
}: {
  profile: { id: number }
}) => {
  ga.track('complete_registration')
  adjust.track('Complete Registration', profile.id)
  amplitude.track('user_complete_registration', {
    ...baseWebEventProps(),
    action_name: 'register',
    action_type: 'active',
  })
}
